<!-- src/components/ezer/EzerToolStatus.vue -->
<template>
  <div class="ezer-tool" :class="`ezer-tool--${tool.status}`">
    <span class="ezer-tool__icon">
      <svg v-if="tool.status === 'running'" class="ezer-spin" viewBox="0 0 16 16" width="14" height="14" fill="currentColor"><path d="M8 1.5a6.5 6.5 0 1 0 6.5 6.5A.75.75 0 0 1 16 8a8 8 0 1 1-8-8 .75.75 0 0 1 0 1.5z"/></svg>
      <svg v-else-if="tool.status === 'success'" viewBox="0 0 16 16" width="14" height="14" fill="#16a34a"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm3.78-9.72a.75.75 0 0 0-1.06-1.06L7 8.94 5.28 7.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.06 0l4.25-4.25z"/></svg>
      <svg v-else viewBox="0 0 16 16" width="14" height="14" fill="#dc2626"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM5.354 5.354a.5.5 0 0 1 .707 0L8 7.293l1.94-1.94a.5.5 0 0 1 .707.708L8.707 8l1.94 1.94a.5.5 0 0 1-.707.707L8 8.707l-1.94 1.94a.5.5 0 0 1-.707-.707L7.293 8 5.354 6.06a.5.5 0 0 1 0-.707z"/></svg>
    </span>
    <span class="ezer-tool__label">{{ friendlyName }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'
export default {
  name: 'EzerToolStatus',
  props: { tool: Object },
  setup(props) {
    const friendlyName = computed(() => {
      return (props.tool.name || '')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase())
    })
    return { friendlyName }
  },
}
</script>
